<template>
  <div class="container w-480">
    <div class="column is-12">
      <!--<h3 class="title has-text-grey">Sign in</h3>-->
      <div class="box">
        <form>
          <div
            v-google-signin-button="googleSignInParams.client_id"
            class="button is-danger is-medium is-fullwidth google-signin-button"
            @click.native="googleIsLoading = true">
            Sign in with Google
          </div>

          <p class="has-text-centered my-2">
            or
          </p>
          <!--<div class="field">-->
          <!--<div class="control">-->
          <!--<input class="input is-medium" type="email" placeholder="Your Email" autofocus="">-->
          <!--</div>-->
          <!--</div>-->

          <div
            v-if="error"
            class="message is-danger">
            <div
              class="message-body">
              <span v-html="error"></span>
              <router-link
                v-if="error && error.indexOf('Invalid username and password') !== -1"
                :to="{name: 'SignUp'}">Sign up</router-link>
            </div>
          </div>

          <b-field>
            <b-input
              id="email"
              v-model="form.email"
              type="text"
              required
              autofocus
              size="is-medium"
              placeholder="Email"
            />
          </b-field>

          <b-field>
            <b-input
              id="password"
              v-model="form.password"
              type="password"
              required
              password-reveal
              size="is-medium"
              placeholder="Password"
            />
          </b-field>

          <b-field class="has-text-left">
            <b-checkbox v-model="form.checked">
              Remember me
            </b-checkbox>
            <!--<a style="float: right" href="/">login?</a>-->
          </b-field>


          <button
            id="btn_sign_in"
            :class="{'is-loading': isLoading, 'is-disabled': isLoading}"
            class="button is-block is-primary is-outlined is-medium is-fullwidth"
            @click="onSubmit($event)">
            Sign in
          </button>
        </form>

      </div>
      <p class="has-text-white">
        <router-link :to="{name: 'SignUp'}">Sign up</router-link> &nbsp;·&nbsp;
        <a href="mailto:guillaume@frequencylist.com">Help!</a>
      </p>
    </div>
  </div>

</template>


<script>

  import GoogleSignInButton from 'vue-google-signin-button-directive'

export default {
  name: "SignIn",
  directives: {
    GoogleSignInButton
  },
  data() {
    return {
      gdprConcented: false,
      error: null,
      googleIsLoading: false,
      redirect: null,
      form: {
        email: "",
        password: "",
        checked: true
      },
      isLoading: false,
      googleSignInParams: {
        client_id: '271833066394-5cabmp4f2e6u5absa42afnno7ct5t19b.apps.googleusercontent.com',
        response_type: "permission",
        // scope: 'https://www.googleapis.com/auth/calendar.readonly'
      }
    };
  },
  created() {
    if (!this.$auth.check()) {
      this.$store.dispatch("setLayout", "front-layout");
    } else {
      this.$router.push("/");
    }
  },

  methods: {
    onSubmit(evt) {
      this.isLoading = true;
      evt.preventDefault();
      const router = this.$router;
      this.$auth
        .login({
          body: this.form,
          redirect: this.redirect || { name: "ListPage" },
          rememberMe: this.form.checked
        })
        .then(
          (res) => {
            this.$store.dispatch("setUser", res.body.data);
            if (this.$route.path === "/sign_in") {
              router.push('/')
            }
            // this.$store.dispatch('setLayout', 'logged-in-layout').then(function(){
            //   router.push('/')
            // })
            this.$emit('close');
          },
          (res) => {
            console.log("error " + this.context);
            this.error = res.data.message;
            console.log("error ", this.error);
            this.isLoading = false;
          }
        );

      // axios.post(`http://localhost:8081/sign_up`, this.form)
      //   .then(response => {
      //     // JSON responses are automatically parsed.
      //     console.log('AUTH RESPONSE: ', response)
      //     // this.form = response.data;
      //     // this.$store.dispatch('setUser', response.data)
      //
      //     this.$localStorage.set('token',response.data.token);
      //     this.$router.push('/home')
      //     // if(this.form.status === 200)
      //     //   this.$refs.modal.show()
      //   })
      //   .catch(e => {
      //     console.log(e)
      //   })
    },
    onClick(e) {
      e.preventDefault();
      this.$router.push("/");
    },
    OnGoogleAuthSuccess(access_token) {
      this.$store.dispatch("setUserFromGoogle", {
        access_token
      }).then((res) => {
        this.$auth.user(res.user)
        this.$store.dispatch("setUser", res.user);
        this.$auth.token(null, res.token)
        this.$auth.watch.authenticated = true
        this.$auth.watch.loaded = true
        this.$cookie.set('rememberMe', true, 365)
        // this.$store.dispatch("setLayout", "logged-in-layout");
        // this.$router.push({name: 'Home'})
        if (this.$route.path === "/sign_in") {
          this.$router.push('/')
        }
        this.$emit('close');
      });
    },
    OnGoogleAuthFail(error) {
      // console.log("OH NOES", error);
      this.googleIsLoading = false;
    }
  }
  /*created(evt) {
    console.log(evt)
      evt.preventDefault()
      axios.post(`http://localhost:3003/api/register`, this.form)
      .then(response => {
        // JSON responses are automatically parsed.
        this.form = response.data
      })
      .catch(e => {
        console.log(e)
      })


    },*/
};
</script>


<style scoped>
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}

.avatar-wrapper {
  border-radius: 50%;
}
.avatar img {
  padding: .5rem;
  background: #fff;
  width: 128px;
  height: 128px;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

@media screen and (max-width: 425px) {
  .avatar {
    margin-top: -42px;
  }
  .avatar img {
    width: 50px;
    height: 50px;
  }
}

input {
  font-weight: 300;
}

p {
  font-weight: 700;
}

p.subtitle {
  padding-top: 1rem;
}

a {
  text-decoration: none;
}

.container {
  width: 400px;
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue